/**
 * 
 */
export default [
    {
        text: "N° DE REGISTRO",
        value: "id",
    },
    {
        text: "tipo",
        value: 'type',
    },
    {
        text: "datos",
        value: ({ id, pivot, type }) => {
            switch (type) {
                case 'Documento banco': return `N° de documento: ${pivot.data.bank_document_number}`
                case 'Débito': return `N° de voucher: ${pivot.data.voucher_number}`
                case 'Efectivo': return `Redondeo: ${pivot.data.rounding}`
                default: return pivot.data
            }
        },
    },
    {
        text: "monto",
        value: ({ pivot }) => pivot.amount,
        align: "right",
        format: "currency",
    },
    {
        text: "creacion",
        value: "created_at",
        align: "right",
        format: "datetime",
    },
    {
        text: "modificacion",
        value: "updated_at",
        align: "right",
        format: "datetime",
    },
]
